import { defineMessages } from 'react-intl';

export default defineMessages({
	title: {
		id: 'lifetimegiftcard.meta.title',
		defaultMessage: 'Gift a Lifetime of Calm',
		description: 'Meta title for lifetime-gift-card',
	},
	description: {
		id: 'lifetimegiftcard.meta.description',
		defaultMessage:
			'Make someone’s day by gifting them a lifetime subscription to Calm Premium. Spread the joys of better sleep, health, and peace of mind',
		description: 'Description title for lifetime-gift-card',
	},
});
